// src/pages/Logout.js

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../UserContext';
import { clearTokens } from '../utils/auth';
import { useWebSocket } from '../services/WebSocketProvider';

const Logout = () => {
  const navigate = useNavigate();
  const { setAccountId, setUserId, setChatId } = useUser();
  const { closeWebSocket } = useWebSocket();

  useEffect(() => {
    const performLogout = async () => {
      try {
        console.log('Starting logout process...');
        
        // Clear local storage first
        clearTokens();
        console.log('Tokens cleared');

        // Close WebSocket connection
        closeWebSocket();
        console.log('WebSocket closed');

        // Reset user context
        setAccountId(null);
        setUserId(null);
        setChatId(null);
        console.log('User context reset');

        // Small delay to ensure state updates are processed
        setTimeout(() => {
          console.log('Navigating to login...');
          navigate('/login', { replace: true });
        }, 100);

      } catch (error) {
        console.error('Error during logout:', error);
        // Even if there's an error, we should still clear local data and redirect
        clearTokens();
        closeWebSocket();
        setAccountId(null);
        setUserId(null);
        setChatId(null);
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 100);
      }
    };

    performLogout();
  }, [navigate, setAccountId, setUserId, setChatId, closeWebSocket]);

  return (
    <div className="auth-page">
      <div className="auth-form">
        <h1>Logging Out</h1>
        <p>Please wait while we log you out...</p>
      </div>
    </div>
  );
};

export default Logout;